import { PencilIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import React from "react";
import UserServices from "../../services/UserServices";
import { useEffect } from "react";
import { useState } from "react";
import fire from "./../../utils/Toastr";
import { HollowDotsSpinner } from "react-epic-spinners";
import BackButton from "../../components/BackButton";
export default function ViewUser() {
  const [users, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [adminType, setAdminType] = useState("");

  const name = new URLSearchParams(window.location.search).get("id");

  const viewDetails = async () => {
    const user = await UserServices.viewDetails(name);
    setUser(user.data);
    const details = sessionStorage.getItem("user");
    const newAdmin = JSON.parse(details);
    setAdminType(newAdmin.adminType.toLowerCase());
  };
  const unblock = async () => {
    setLoading(true);
    const resp = await UserServices.unBlockAccount(name);
    if (resp) {
      fire("success", "Account unblocked successfully");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      setLoading(false);
    }
  };

  const approve = async () => {
    setLoading(true);
    const resp = await UserServices.activateUser({ userName: name });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.reload();
        window.location.href = "/users";
      }, 4000);
      setLoading(false);
    }
  };
  useEffect(() => {
    viewDetails();
  }, []);
  return (
    <>
      <Layout pageTag={"admin"} current={"/users"}>
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto">
              <BackButton />
            </div>
            <div className="py-6">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  User Details
                </h1>
              </div>
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="">
                <div className="px-4 sm:px-6 lg:px-8">
                  <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto flex"></div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none ">
                      {adminType === "checker" && users.isActive === false ? (
                        <>
                          {loading === false ? (
                            <button
                              onClick={approve}
                              type="button"
                              className="inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                            >
                              <PencilIcon className="w-4 mr-1.5" />
                              Activate User
                            </button>
                          ) : (
                            <HollowDotsSpinner size={20} color="#4D627E" />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="mt-8 flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <form className="px-6">
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="firstname"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      First name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="firstname"
                                        id="firstname"
                                        value={users.firstName}
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="lastName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Last name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="lastName"
                                        id="lastName"
                                        value={users.surname}
                                        autocomplete="given-name"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Email
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={users.emailAddress}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="branch"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Branch
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="branch"
                                        id="branch"
                                        value={users.branchName}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="role"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Role
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        name="role"
                                        id="role"
                                        value={users.roleName}
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-4 flex justify-end">
                                  {adminType === "checker" &&
                                  users.isLocked === true ? (
                                    <>
                                      {" "}
                                      {loading === false ? (
                                        <button
                                          type="submit"
                                          onClick={unblock}
                                          className="hover:text-white active:text-white btn-primary text-white inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                                        >
                                          Unblock User
                                        </button>
                                      ) : (
                                        <HollowDotsSpinner
                                          size={20}
                                          color="#4D627E"
                                        />
                                      )}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
